import React from "react";

const PrintSvg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="24"
        viewBox="0 0 30 24"
        fill="none"
      >
        <rect
          x="8.03464"
          y="0.65"
          width="13.4692"
          height="22.7"
          fill="white"
          stroke="#118BF4"
          strokeWidth="1.3"
        ></rect>
        <mask id="path-2-inside-1_1142_32719" fill="white">
          <rect
            x="10.1538"
            y="15.6924"
            width="9.23077"
            height="1.84615"
            rx="0.5"
          ></rect>
        </mask>
        <rect
          x="10.1538"
          y="15.6924"
          width="9.23077"
          height="1.84615"
          rx="0.5"
          stroke="#118BF4"
          strokeWidth="1.84615"
          mask="url(#path-2-inside-1_1142_32719)"
        ></rect>
        <mask id="path-3-inside-2_1142_32719" fill="white">
          <rect
            x="10.1538"
            y="19.3848"
            width="7.38462"
            height="1.84616"
            rx="0.5"
          ></rect>
        </mask>
        <rect
          x="10.1538"
          y="19.3848"
          width="7.38462"
          height="1.84616"
          rx="0.5"
          stroke="#118BF4"
          strokeWidth="1.84616"
          mask="url(#path-3-inside-2_1142_32719)"
        ></rect>
        <path
          d="M0.65 7.61524C0.65 6.31737 1.70213 5.26523 3 5.26523H26.5385C27.8363 5.26523 28.8885 6.31737 28.8885 7.61523V18.3845C28.8885 18.5778 28.7318 18.7345 28.5385 18.7345H21.5759C21.3826 18.7345 21.2259 18.5778 21.2259 18.3845V14.846C21.2259 13.9347 20.4872 13.196 19.5759 13.196H9.52605C8.61478 13.196 7.87605 13.9347 7.87605 14.846V18.3845C7.87605 18.5778 7.71935 18.7345 7.52605 18.7345H1C0.8067 18.7345 0.65 18.5778 0.65 18.3845V7.61524Z"
          fill="white"
          stroke="#118BF4"
          strokeWidth="1.3"
        ></path>
        <path
          d="M5.81149 10.6156C5.81149 11.0213 5.48259 11.3502 5.07688 11.3502C4.67116 11.3502 4.34226 11.0213 4.34226 10.6156C4.34226 10.2099 4.67116 9.88096 5.07688 9.88096C5.48259 9.88096 5.81149 10.2099 5.81149 10.6156Z"
          stroke="#118BF4"
          strokeWidth="1.3"
        ></path>
      </svg>
    </>
  );
};

export default PrintSvg;
